import React from 'react';
import { useNavigate } from 'react-router-dom';

// Minimal, safe markdown renderer for the chat: **bold**, *italic*, [text](url),
// bullet lists, horizontal rules and paragraphs. Internal links use react-router.
const renderInline = (text, navigate, keyBase) => {
  const nodes = [];
  const regex = /(\*\*([^*]+)\*\*)|(\*([^*]+)\*)|(\[([^\]]+)\]\(([^)\s]+)\))/g;
  let last = 0, m, k = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[1]) nodes.push(<strong key={`${keyBase}-b${k++}`}>{m[2]}</strong>);
    else if (m[3]) nodes.push(<em key={`${keyBase}-i${k++}`}>{m[4]}</em>);
    else if (m[5]) {
      const label = m[6], href = m[7];
      if (href.startsWith('/')) {
        nodes.push(
          <a key={`${keyBase}-l${k++}`} href={href}
            onClick={(e) => { e.preventDefault(); navigate(href); }}
            className="text-rose-italic font-medium underline underline-offset-2 cursor-pointer hover:text-mahogany">{label}</a>
        );
      } else {
        nodes.push(
          <a key={`${keyBase}-l${k++}`} href={href} target="_blank" rel="noopener noreferrer"
            className="text-rose-italic font-medium underline underline-offset-2 hover:text-mahogany">{label}</a>
        );
      }
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
};

const Markdown = ({ text }) => {
  const navigate = useNavigate();
  const lines = (text || '').split('\n');
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) {
      blocks.push(<ul key={`ul-${blocks.length}`} className="list-disc pl-5 space-y-1 my-1.5">{list}</ul>);
      list = [];
    }
  };
  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (/^\s*(-{3,}|\*{3,})\s*$/.test(line)) { flush(); blocks.push(<hr key={`hr-${i}`} className="my-3 border-rose/30" />); return; }
    const li = line.match(/^\s*[-*]\s+(.*)$/);
    if (li) { list.push(<li key={`li-${i}`}>{renderInline(li[1], navigate, `li${i}`)}</li>); return; }
    flush();
    if (line.trim() === '') { return; }
    blocks.push(<p key={`p-${i}`} className="my-1.5 leading-relaxed">{renderInline(line, navigate, `p${i}`)}</p>);
  });
  flush();
  return <div className="text-[15px]">{blocks}</div>;
};

export default Markdown;
